import { EnqueueSnackbar } from 'notistack';
import { axiosRef } from '../../../api';
import { mapJobSummaryToPayload } from '../functions';
import { JobSummary } from '../interfaces';

export default async function putJobSummary(
  summary: JobSummary,
  setLoading: (loading: boolean) => void,
  enqueueSnackbar: EnqueueSnackbar,
) {
  setLoading(true);
  try {
    const response = await axiosRef
      .put(
        `/job_summary/${summary.id}`,
        mapJobSummaryToPayload(summary)
      );
    if (!response?.data?.is_error && response?.data?.content) {
      setLoading(false);
      enqueueSnackbar(
        'Job details have been updated',
        {
          variant: 'success',
        },
      );
      const content = response.data.content;
      return {
        actualPickupDate: content.actual_pickup_date,
        bbeNumber: content.bbe_number,
        creationDate: content.creation_date,
        description: content.description,
        handoffLocation: content.handoff_location,
        id: content.id,
        initialPlannedPickupDate: content.initial_planned_pickup_date,
        initialPlannedStagingDate: content.initial_planned_staging_date,
        priorityName: content.priority_name,
        purchaseOrder: content.purchase_order,
        revisedPickupDate: content.revised_pickup_date,
        revisedStagingDate: content.revised_staging_date,
        statusName: content.status_name,
        totalShipments: content.total_shipments,
        totalWeight: content.total_weight,
        travelModeName: content.travel_mode_name,
        vendor: content.vendor,
      }
    }
    setLoading(false);
    return {};
  } catch (error) {
    setLoading(false);
    return {};
  }
}
